import { useNavigate, useParams } from 'react-router-dom'

import { QuoteRedirectPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

const QuoteRedirectPage = () => {
  const { quoteId } = useParams()
  const {
    company: { id: companyId },
  } = useCurrentSession()
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { data, loading } = useQuery(QuoteRedirectPageDocument, {
    variables: {
      companyId,
    },
  })

  const hasQuickQuoteBuilderFeature = !!data?.features.featuresConnection.nodes.find(
    (feature) => feature.name === 'dev_quick_quote_builder'
  )?.enabled

  const getRedirectUrl = () => {
    if (hasQuickQuoteBuilderFeature) {
      return navigation.finance.sales.quotes.quoteId.pricing.fullPath({
        quoteId: quoteId ?? '0',
      })
    } else {
      return navigation.finance.sales.quotes.quoteId.edit.fullPath({ quoteId: quoteId ?? '0' })
    }
  }

  useEffect(() => {
    if (!loading) {
      navigate(getRedirectUrl())
    }
  }, [loading])

  return <></>
}

export default QuoteRedirectPage
